/* 放全局的常量 */
import requestCode from './requestResponse'

/* 放全局的常量 */
export default {
  PROJECT: 'smartdevice',
  VERSIONNUM: '1.0.',
  VERSION: this.PROJECT + this.VERSIONNUM,
  requestCode
}



// WEBPACK FOOTER //
// ./src/area-base/utils/constant.js